import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProductFilledSvg from "@ant-design/icons-svg/es/asn/ProductFilled";
import AntdIcon from '../components/AntdIcon';
var ProductFilled = function ProductFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ProductFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ProductFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ProductFilled';
}
export default RefIcon;